import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFedopsLogger } from '../Provider/Fedops/FedopsProvider';
import { InteractionName } from '../../types/InteractionName';
import { selectTopProps } from '../../selectors';
import { selectAvailableMethods } from '../../selectors/payment';
import { useOnPaymentMethodsAmountInit } from './useOnPaymentMethodsAmountInit';
import { useBI } from './hooks/useBI';
import { PaymentMethodsListView } from './view';

export function PaymentMethodsListController() {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { layout } = useSelector(selectTopProps);
  const availableMethods = useSelector(selectAvailableMethods);
  const fedopsLogger = useFedopsLogger();
  const bi = useBI();

  const onMorePaymentOptionsClick = useCallback(() => {
    bi.reportMoreOptionsClicked();
    setIsExpanded(true);
  }, [bi, dispatch]);

  useOnPaymentMethodsAmountInit();

  useEffect(() => {
    fedopsLogger.interactionEnded(InteractionName.FMP);
    fedopsLogger.appLoaded();
    bi.reportLoaded();
  }, []);

  if (availableMethods.length === 0) {
    return null;
  }

  return <PaymentMethodsListView isExpanded={isExpanded} layout={layout} onExpand={onMorePaymentOptionsClick} />;
}
